// The floating "Ask Mae" button on a phone (MobileAdvisorEntry) never covers what a
// page marks with data-hides-ask-mae: on the home page, the hero (the headline and the
// search box) and the page's own Ask Mae card. While any marked element is on screen
// the button is hidden; it appears once the buyer has scrolled past them. Pages that
// mark nothing keep the button as before.
//
// Pure: no DOM.

export const HIDES_ASK_MAE_ATTR = "data-hides-ask-mae";

export type Box = { top: number; bottom: number };

// Whether any marked box is at least partly on screen.
export function askMaeBlocked(boxes: readonly Box[], viewportHeight: number): boolean {
  return boxes.some(box => box.bottom > 0 && box.top < viewportHeight);
}
